export const add_file = 'add_file';
export const cropper_modal_cancel = 'cropper_modal_cancel';
export const error_modal_cancel = 'error_modal_cancel';
export const set_err = 'set_err';
export const reset_state = 'reaet_state';
export const set_crop = 'set_crop';
export const set_zoom = 'set_zoom';
export const set_cropped_area_pxls = 'set_cropped_area_pxls';
export const set_file_data = 'set_file_data';
export const close_modal = 'close_modal';
